module.exports = __webpack_public_path__ + "static/media/Resend.1f5b03c0.svg";